import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import analysts_Debater_ENTP_personality_header from '../../images/personality_types_details/analysts_Debater_ENTP_personality_header.svg'
import analysts_Debater_ENTP_conclusion from '../../images/personality_types_details/analysts_Debater_ENTP_conclusion.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const entp_conclusion = () => {
    return (
        <Layout>
            <main class="q-td analyst debater">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/debator-entp-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/debator-entp-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/debator-entp-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/debator-entp-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/debator-entp-careers" className="tab with-progress">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/debator-entps-at-work" className="tab with-progress">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/debator-entp-conclusion" className="tab with-progress active">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header class="type-header analyst debater">

                    <svg class="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path class="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path class="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>

                    <img src={analysts_Debater_ENTP_personality_header} class="scene" alt='loading...' />
                    <div class="type-info">
                        <h1><span>Debater</span> Personality</h1>
                        <div class="code">ENTP-A / ENTP-T</div>
                        <a href="#" class="difference">(What’s the difference?)</a>
                    </div>

                </header>


                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/debator-entp-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/debator-entp-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/debator-entp-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/debator-entp-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/debator-entp-parents">Parenthood</Link></li>
                                <li className=""><Link to="/personality-types/debator-entp-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/debator-entps-at-work">Workplace Habits</Link></li>
                                <li className="active"><Link to="/personality-types/debator-entp-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                    <h1>Conclusion</h1>

                    
                        <p>Armed with a powerful intellect and vivid imagination, Debaters can overcome or outmaneuver obstacles that seem unbeatable to most. At the same time, their many quirks, such as often unconstrained rationalism, lead to many misunderstandings. Those misunderstandings end here. What you have read so far is just an introduction – we have a great deal more to tell you about the Debater personality type.</p>

<p>At some point in reading through your results, you probably hit a tipping point. You went from trademark Debater skepticism to “huh...” to “wait, what?” You may even be a little uncomfortable because you are really not used to being understood, even by the people you’re closest to.</p>

<p>Chances are, you’ve accepted that as part of who you are, and maybe even grown proud of it. But embracing that disconnection isn’t a requirement for Debaters. It’s a misused defense mechanism, leading you down a lonely, inefficient path – gaining insight into yourself and others is so much more rewarding.</p>

<div class="scene">
    <img alt="Debater (ENTP) personality" src={analysts_Debater_ENTP_conclusion}/>
</div>

<p>This is no date-of-birth gimmick, and no, we did not spy on you – rather, we’ve spent years studying Debaters’ life stories, experiences, and patterns in hundreds of our surveys. Step by step, insight by insight, we discovered how those who share your qualities and outlook have overcome the challenges they’ve faced. You are a unique individual, but you are not alone in this. It’s wise to learn from others’ experiences – and we’d really like to share those insights with you.</p>

<p>As you move forward into the e-books and interactive courses we offer, we go much deeper into the Debater mind. We answer not just “what”, but “why?”, “how?” and “what if?” Why do you act the way you do? How do you find motivation and inspiration? What if you moved beyond fear to pursue what you secretly want to achieve in life?</p>

<p>We can show you how to use your strengths to unlock your exceptional potential and avoid common pitfalls, while also staying true to who you are – after all, that’s the point. To see how you can grow to be the person you know you’re capable of being, in ways that finally feel right – read on, Debater.</p>

                    <div class="number">08</div>

                    
                </article>


                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/debator-entps-at-work' className='next-feature'>
                            Workplace Habits
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/' className='next-feature'>
                            Premium Profile
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default entp_conclusion
